<template>
    <el-row :gutter="30">
        <div class="name" style="padding:10px;">
            <span class="demonstration">年份</span>
            <el-date-picker value-format="yyyy" v-model="value1" type="year" placeholder="选择年" @change="handleQuery"
                :picker-options="pickerOptions0">
            </el-date-picker>
        </div>
        <el-col :span="12">
            <el-card class="box-card_totle">
                <div class="top">
                    <div class="left"></div>
                </div>
                <div class="echart" id="peopleProjectYear" :style="myChartStyle" v-show="hourYearData.length > 0"></div>
                <el-empty v-show="hourYearData.length == 0" style="height:380px;"></el-empty>
            </el-card>
        </el-col>
        <el-col :span="12">
            <el-card class="box-card_totle">
                <div class="top">
                    <div class="left"></div>
                </div>
                <div class="echart" id="employeeConsumeYear" :style="myChartStyle" v-show="employeeYearData.length > 0">
                </div>
                <el-empty v-show="employeeYearData.length == 0" style="height:380px;"></el-empty>
            </el-card>
        </el-col>
        <div class="top" style="padding: 10px; display: flex">
            <div class="left">
                <div class="name">
                    <div class="block">
                        <span class="demonstration">月份</span>
                        <el-date-picker value-format="yyyy-MM" v-model="value2" type="month" placeholder="选择月"
                            @change="handleQueryDate" :picker-options="pickerOptions0">
                        </el-date-picker>
                        <!-- <el-button type="primary" icon="el-icon-search" size="medium" @click="handleQueryDate">确认
            </el-button> -->
                    </div>
                </div>
            </div>
        </div>
        <el-col :span="12">
            <el-card class="box-card_totle">
                <div class="top">
                    <div class="left"></div>
                </div>
                <div class="echart" id="peopleProjectMonth" :style="myChartStyle" v-show="hourMonthData.length > 0"></div>
                <el-empty v-show="hourMonthData.length == 0" style="height:380px;"></el-empty>
            </el-card>
        </el-col>
        <el-col :span="12">
            <el-card class="box-card_totle">
                <div class="top">
                    <div class="left"></div>
                </div>
                <div class="echart" id="employeeConsumeMonth" :style="myChartStyle" v-show="employeeMonthData.length > 0">
                </div>
                <el-empty v-show="employeeMonthData.length == 0" style="height:380px;"></el-empty>
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
import * as echarts from "echarts";

export default {
    data() {
        return {
            value1: "",
            value2: "",
            hourYearData: [],
            hourMonthData: [],
            employeeYearData: [],
            employeeMonthData: [],
            pickerOptions0: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },
            myChartStyle: { float: "left", width: "100%", height: "400px" } //图表样式
        };
    },

    mounted() {
        var date = new Date();
        var year = date.getFullYear().toString();
        var month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        var toMonth = year + "-" + month;
        this.value1 = year;
        this.value2 = toMonth;
        this.initDate();
        this.initDateMouth();
    },
    methods: {
        initDate() {
            let p1 = new Promise((resolve, reject) => {
                httpKit
                    .post($api_pms.home.employeeProject, { 'month': this.value1 })
                    .then(res => {
                        // this.refreshing = false;
                        console.log(res);
                        if (res.data.code === '200') {
                            console.log('ok');
                            if (res.data.data.length > 0) {
                                this.hourYearData = res.data.data;
                                console.log(this.hourYearData)
                            } else {
                                this.hourYearData = [];
                                console.log(this.hourYearData)
                            }
                            resolve(this.hourYearData);
                        } else if (res.data.code === '500') {
                            this.$message.error('系统发生错误：' + res.data.msg);
                            console.log('err');
                        }
                    });
            });
            let p2 = new Promise((resolve, reject) => {
                httpKit
                    .post($api_pms.home.employeeConsumeProject, { 'month': this.value1 })
                    .then(res => {
                        // this.refreshing = false;
                        console.log(res);
                        if (res.data.code === '200') {
                            console.log('ok');
                            if (res.data.data.length > 0) {
                                this.employeeYearData = res.data.data;
                                console.log(this.employeeYearData)
                            } else {
                                this.employeeYearData = [];
                                console.log(this.employeeYearData)
                            }
                            resolve(this.employeeYearData);
                        } else if (res.data.code === '500') {
                            this.$message.error('系统发生错误：' + res.data.msg);
                            console.log('err');
                        }
                    });
            });
            Promise.all([p1, p2])
                .then((result) => {
                    this.initEcharts();
                })
                .catch((error) => {
                    console.log(111111111, error);
                });
        },
        initDateMouth() {
            let p1 = new Promise((resolve, reject) => {
                httpKit
                    .post($api_pms.home.employeeProject, { 'month': this.value2 })
                    .then(res => {
                        // this.refreshing = false;
                        console.log(res);
                        if (res.data.code === '200') {
                            console.log('ok');
                            if (res.data.data.length > 0) {
                                this.hourMonthData = res.data.data;
                                console.log(this.hourMonthData)
                            } else {
                                this.hourMonthData = [];
                                console.log(this.hourMonthData)
                            }
                            resolve(this.hourYearData);
                        } else if (res.data.code === '500') {
                            this.$message.error('系统发生错误：' + res.data.msg);
                            console.log('err');
                        }
                    });
            });
            let p2 = new Promise((resolve, reject) => {
                httpKit
                    .post($api_pms.home.employeeConsumeProject, { 'month': this.value2 })
                    .then(res => {
                        // this.refreshing = false;
                        console.log(res);
                        if (res.data.code === '200') {
                            console.log('ok');
                            if (res.data.data.length > 0) {
                                this.employeeMonthData = res.data.data;
                                console.log(this.employeeMonthData)
                            } else {
                                this.employeeMonthData = [];
                                console.log(this.employeeMonthData)
                            }
                            resolve(this.employeeMonthData);
                        } else if (res.data.code === '500') {
                            this.$message.error('系统发生错误：' + res.data.msg);
                            console.log('err');
                        }
                    });
            });
            Promise.all([p1, p2])
                .then((result) => {
                    this.initEcharts();
                })
                .catch((error) => {
                    console.log(111111111, error);
                });
        },
        handleQuery() {
            this.initDate();
        },
        handleQueryDate() {
            this.initDateMouth();
        },
        initEcharts() {
            this.$nextTick(() => {
                var myEvent = new Event("resize"); // 创建一个支持冒泡且不能被取消的resize事件
                window.dispatchEvent(myEvent); // 事件可以在任何元素触发
            });
            // 饼图
            const optionProjectYear = {
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{b}:{c} ({d}%)" // b代表名称，c代表对应值，d代表百分比
                        },
                        radius: "70%", //饼图半径
                        data: this.hourYearData
                    }
                ],
                title: {
                    text: '按年统计项目消耗工时',
                    left: 'center'
                }
            };
            const optionEmployeeYear = {
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{b}:{c} ({d}%)" // b代表名称，c代表对应值，d代表百分比
                        },
                        radius: "70%", //饼图半径
                        data: this.employeeYearData
                    }
                ],
                title: {
                    text: '按年统计项目消耗成本',
                    left: 'center'
                }
            };
            const optionProjectMonth = {
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{b}:{c} ({d}%)" // b代表名称，c代表对应值，d代表百分比
                        },
                        radius: "70%", //饼图半径
                        data: this.hourMonthData
                    }
                ],
                title: {
                    text: '按月份项目消耗工时',
                    left: 'center'
                }
            };
            const optionEmployeeMonth = {
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{b}:{c} ({d}%)" // b代表名称，c代表对应值，d代表百分比
                        },
                        radius: "70%", //饼图半径
                        data: this.employeeMonthData
                    }
                ],
                title: {
                    text: '按月份统计项目消耗成本',
                    left: 'center'
                }
            };
            this.peopleProjectYear = echarts.init(document.getElementById("peopleProjectYear"));
            this.peopleProjectYear.setOption(optionProjectYear);
            this.employeeConsumeYear = echarts.init(document.getElementById("employeeConsumeYear"));
            this.employeeConsumeYear.setOption(optionEmployeeYear);
            this.peopleProjectMonth = echarts.init(document.getElementById("peopleProjectMonth"));
            this.peopleProjectMonth.setOption(optionProjectMonth);
            this.employeeConsumeMonth = echarts.init(document.getElementById("employeeConsumeMonth"));
            this.employeeConsumeMonth.setOption(optionEmployeeMonth);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.peopleProjectYear.resize();
                this.employeeConsumeYear.resize();
                this.peopleProjectMonth.resize();
                this.employeeConsumeMonth.resize();
            });
        }
    }
};
</script>